<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Functional Card
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <ng-container *ngIf="!isBrowser; else inputOptionControls">
          <form action="/function-card" method="get">
            <ng-container *ngTemplateOutlet="inputOptionControls"></ng-container>
            <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button><br>
          </form>
          <h2>Note: You are in noJS mode, So please hit submit after the options changes.</h2>
        </ng-container>
      </div>
    </div>
  </div>
  <maced-function-card functionCardId="functionCardId" name="functionCardCheckbox"
    [icon]="showIcon ? 'icon-check-circle' : ''" [title]="title" [hasDraggable]="showDragable"
    [hasSelectable]="withoutDragActions && !showIconClass" iconTitle="Complete" draggableTitle="Draggable"
    [hasFunctioncardLabel]="false" [hasDraggableRole]="false" [levelProjectedContent]="true">
  <ng-container ngProjectAs="[panelHeader]">
    <h3 class="c-function-card__title">{{ title }}</h3>
  </ng-container>
    <ng-container *ngIf="isMobileView && !showIconClass && withoutDragActions " ngProjectAs="[functionalCardBadge]">
      <div class="c-funtion-card__badge-container">
        <maced-badge badgeId="badgeId" [label]="badge2" ariaLabel="badge aria-label" size="small"></maced-badge>
      </div>
    </ng-container>
    <ng-container ngProjectAs="[functionalCardDescription]">
      <ul class="c-function-card__list" role="list">
        <li class="c-function-card__list-item" role="listitem">
          <span class="c-function-card__list-item-label">Label:</span>
          Placeholder text
        </li>
        <li class="c-function-card__list-item" role="listitem">
          <span class="c-function-card__list-item-label">Label:</span>
          Placeholder text
        </li>
        <li class="c-function-card__list-item" role="listitem">
          <span class="c-function-card__list-item-label">Label:</span>
          Placeholder text
          <span class="u-icon icon-delete c-function-card-icon" role="img" aria-label="delete icon"></span>
        </li>
      </ul>
    </ng-container>
    <ng-container ngProjectAs="[functionalCardActions]">
      <maced-button buttonId="buttonId1" label="Primary Action" ariaLabel="Primary Action" color="secondary">
      </maced-button>
      <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown"
        cheveronClass="icon-dots-vertical" [options]="options">
      </maced-dropdown>
    </ng-container>
    <ng-container ngProjectAs="[functionalCardMobileActions]">
      <maced-button buttonId="buttonId1" label="Primary Action" ariaLabel="Primary Action" color="secondary">
      </maced-button>
      <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown"
        cheveronClass="icon-dots-vertical" [options]="options">
      </maced-dropdown>
    </ng-container>
    <ng-container ngProjectAs="[functionalCardAccordian]">
      <maced-accordian-group accordianGroupId="accordianGroupId">
        <maced-accordian accordianId="accordianId1" collapseLabel="Collapse" expandLabel="Expand"
          [hasContentBelow]="false" [hasIconLeftSide]="true" [hasActions]="true" [hasDefaultExpanded]="false"
          [preview]="preview">
          <ng-container ngProjectAs="[accordionContent]">
            <div [innerHTML]="preview"></div>
          </ng-container>
          <ng-container ngProjectAs="[accordionActions]">
            <maced-button buttonId="buttonId2" color="default" size="small" shape="square" buttonType="button"
              label="Action" ariaLabel="action">
            </maced-button>
            <maced-button buttonId="buttonId3" color="default" size="small" shape="square" buttonType="button"
              label="Action" ariaLabel="action">
            </maced-button>
          </ng-container>
        </maced-accordian>
      </maced-accordian-group>
    </ng-container>
  </maced-function-card>
</div>

<ng-template #inputOptionControls>
  <input id="showIconClass" class="c-input-check-inline__input" type="checkbox" name="showIconClass"
    [(ngModel)]="showIconClass" (ngModelChange)="onChangeIcon()">
  <label for="showIconClass" class="c-input-check-inline__label u-mr-15">
    Show Icon
  </label>
  <input id="withoutDragActions" class="c-input-check-inline__input" type="checkbox" name="withoutDragActions"
    [(ngModel)]="withoutDragActions" (ngModelChange)="onChangeIcon()">
  <label for="withoutDragActions" class="c-input-check-inline__label u-mr-15">
    Without Drag Actions
  </label>
</ng-template>